import { t } from 'element-ui/src/locale';

export default {
  methods: {
    t(...args) {
      return t.apply(this, args);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/src/mixins/locale.js
// module id = mGyo
// module chunks = 0